import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export const useNewsletterFlyoutStateManager = () => {
  const {cancel, isOpen, open} = useOpenedStateManager(
    'NEWSLETTER_FLYOUT_STATE_MANAGER',
  );
  return {cancel, isOpen, open};
};
